export const enAgentGuiUsageStatus = {
  slashStatusTitle: "Status",
  slashStatusSession: "Session",
  slashStatusBaseUrl: "Base URL",
  slashStatusContext: "Context",
  slashStatusLimits: "Usage Limits",
  slashStatusAccount: "Account",
  slashStatusProviderAccount: "{{provider}} Account",
  slashStatusClose: "Close",
  slashStatusFiveHourLimit: "5h limit",
  slashStatusWeeklyLimit: "7d limit",
  slashStatusLimitPercentLeft: "{{percent}}% left",
  slashStatusLimitReset: "resets {{reset}}",
  slashStatusContextValue:
    "{{percentLeft}}% left ({{usedTokens}} used / {{totalTokens}})",
  slashStatusContextUnavailable: "Context usage unavailable",
  slashStatusLimitsUnavailable: "Account quota is currently unavailable",
  slashStatusEmptyValue: "—",
  slashStatusUsageJustUpdated: "Updated just now",
  slashStatusUsageMinutesAgo: "Updated {{count}}m ago",
  slashStatusUsageHoursAgo: "Updated {{count}}h ago",
  slashStatusUsageUpdating: "Updating…",
  slashStatusUsageRefreshFailed: "Refresh failed",
  slashStatusUsageRefreshAria: "Refresh usage",
  slashStatusUsageAuthRequired: "Configure an API key or sign in to continue",
  slashStatusUsageSessionExpired: "Your sign-in expired. Sign in again",
  slashStatusUsageSubscriptionRequired:
    "A Coding Plan or subscription is required",
  slashStatusUsageQuotaExhausted: "Account balance or usage quota is exhausted",
  slashStatusUsageParseFailed: "Unable to parse account status",
  slashStatusUsageError: "Unable to load account status",
  usageChipLabel: "Context {{percent}}%",
  usageTooltipLabel: "Context usage",
  usagePopoverTitle: "Context Usage",
  usageContextWindowLabel: "Context window",
  usageTokensLabel: "Tokens",
  usageLimitsLabel: "Limits",
  usageCompactAction: "Compact"
} as const;
